<template>

    <div>
        <v-card flat class="mt-0 pa-0">
            <v-card-text class="cursor-pointer">
                <v-container fluid class="pa-2">
                    <v-row>
                        <v-col cols="12" md12 lg10 xl6>

                            <validation-observer ref="segmentObserver" v-slot="{ errors, invalid }">

                                <validation-provider
                                        name="Qualifying segment"
                                        rules=""
                                        ref="segmentProvider"
                                        v-slot="{ errors }">

                                    <!-- SAMPLE SEGMENT -->
                                    <segment-visualizer
                                            :json-query="data.json_query"
                                            :json-filter="data.json_filter"
                                            :show-business-rules="true"
                                            :disable-edit="true"
                                            :target-completes="targetCompletes"
                                            title-icon="mdi-target"
                                            title-color="#4CAF50"
                                            help="edit-project-segment"
                                            :definition-builder-open="definitionBuilderOpen"
                                            emptySegmentWarning="Segment is not defined. You must define a segment for all projects. Click here to define."
                                            @change="segmentUpdated"
                                            @cancel="segmentCancelled"
                                            @change:selected-sub-panels="selectedSubPanelsChanged"
                                    ></segment-visualizer>

                                </validation-provider>

                            </validation-observer>
                        </v-col>

                        <!-- DISPLAY BUSINESS RULES FOR REFERENCE -->
                        <v-col cols="12" md12 lg10 xl6>

                            <segment-visualizer
                                    :json-query="settings.business_rules_json_query"
                                    :json-filter="settings.business_rules_json_filter"
                                    :show-business-rules="false"
                                    :disable-edit="true"
                                    :definition-builder-open="definitionBuilderOpen"
                                    title="Business Rules"
                                    title-color="#F57F17"
                                    title-icon="mdi-gavel"
                                    help="edit-project-business-rules"
                                    :editable="false"
                                    :selectable-segment="false"
                                    non-editable-info="Business rules can be edited only in Panel Settings with appropriate permissions!"
                                    empty-segment-warning="Business rules have not been setup. Define in the Panel Settings with appropriate permissions"
                            ></segment-visualizer>
                        </v-col>

                    </v-row>
                </v-container>

            </v-card-text>
        </v-card>
    </div>
</template>

<script>

    import SegmentVisualizer from '../../../../Segments/components/SegmentVisualizer';
    import SegmentPickerDialog from '../../../../../components/UI/SegmentPickerDialog';
    import SubPanelSelector from "../../../../../components/UI/SubPanelSelector";
    import {mapState, mapMutations} from 'vuex';
    import Json from 'vue-json-pretty';

    export default {

        components: {
            SegmentVisualizer,
            SegmentPickerDialog,
            Json,
            SubPanelSelector,
        },

        props: {
            jsonQuery: {
                required: true,
                type: Object
            },
            jsonFilter: {
                required: true,
                type: Object
            },
            subPanels: {
                type: Array | null,
                required: true,
            },
            errorMessages: {
                required: false,
                type: Object,
                default: () => {
                    return {
                        name: []
                    }
                }
            },
            targetCompletes: {
                required: true,
                type: Number | null,
                default: null,
            }
        },

        watch: {
            jsonQuery(newQuery) {
                this.data.json_query = newQuery;
            },
            jsonFilter(newFilter) {
                this.data.json_filter = newFilter;
            }
        },

        computed: {
            ...mapState('PanelSettings', [
                'settings',
            ]),
        },

        data() {
            return {
                definitionBuilderOpen: false,
                data: {
                    json_query: null,
                    json_filter: null
                },
            }
        },

        methods: {

            segmentUpdated(segment) {

                this.data.json_query = segment.json_query;
                this.data.json_filter = segment.json_filter;

                this.definitionBuilderOpen = false;
                this.emit();
            },

            segmentCancelled() {
                this.definitionBuilderOpen = false;
            },

            selectedSubPanelsChanged(ids) {
                this.$emit('change:selected-sub-panels',ids);
            },

            emit() {

                if (this.$refs.segmentObserver) {
                    this.$refs.segmentObserver.validate()
                        .then(isValid => {
                            if (isValid) {
                                this.$emit('change', this.data);
                                this.$emit('error', {name: 'tab2', error: false});
                            } else {
                                this.$emit('error', {name: 'tab2', error: true});
                            }
                        });
                }
            },
        },

        created() {
            this.data.json_query = this.jsonQuery;
            this.data.json_filter = this.jsonFilter;

            if (!this.jsonQuery) {
                this.$emit('error', 'Sample Segment must be completed');
            }
        }
    }
</script>
